import { ArrowUp, Wind } from "lucide-react";

import type { PlateRelativeWind } from "@/domain/weather";
import { cn } from "@/shared/lib/cn";

interface DingerBannerProps {
  conditions: PlateRelativeWind | null;
}

export function DingerBanner({ conditions }: DingerBannerProps) {
  if (!conditions) return null;
  const directionLabel = plateRelativeDirectionLabel(
    conditions.directionDegrees,
  );
  return (
    <div
      aria-live="polite"
      className={cn(
        "no-print bg-primary/15 font-mono text-[0.72rem] font-bold tracking-[0.12em] uppercase text-primary",
      )}
    >
      <div className="mx-auto flex min-h-9 max-w-[var(--content-width)] items-center justify-center gap-2 px-[max(0.75rem,var(--safe-left))] py-1 pr-[max(0.75rem,var(--safe-right))]">
        <Wind className="size-3.5 shrink-0" aria-hidden="true" />
        <span className="truncate">Dinger time</span>
        <span aria-hidden="true">·</span>
        <span className="shrink-0">{Math.round(conditions.speedKmh)} km/h</span>
        <span
          role="img"
          aria-label={`Wind blowing ${directionLabel}`}
          title={`Wind blowing ${directionLabel}`}
          className="inline-flex size-4 shrink-0 items-center justify-center"
          style={{
            transform: `rotate(${conditions.directionDegrees}deg)`,
          }}
        >
          <ArrowUp className="size-4" aria-hidden="true" />
        </span>
      </div>
    </div>
  );
}

function plateRelativeDirectionLabel(directionDegrees: number): string {
  const roundedDegrees = Math.round(Math.abs(directionDegrees));
  if (roundedDegrees === 0) return "straight out from home plate";
  return `${roundedDegrees} degrees toward ${directionDegrees > 0 ? "right field" : "left field"} from home plate`;
}
